import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { StaticPermissionsEnum } from "src/app/models/permissions-models/permissions.enums";
import { StaticConfigurationsEnum } from "src/app/models/configurations-models/configurations.enums";
import { AuthPermissionsService } from "src/app/services/auth-permissions-service";


export interface MenuItemLink {
  route?: string;
  name: string;
  icon?: string;
  routeName?: string;
  childrens?: MenuItemLink[];
  role?: string[];
  isAcive?: boolean;
  adminNotAllowed?: boolean;
  notAdmin?: boolean;
  permission?: (number | number[] | null);
  isSuperAdmin?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MenuItems {

  items = [
    {
      name: this.translateService.instant("Master data"),
      route: '/admin/master-data',
      role: ['Admin'],
      hasPermission: false,
      permission: null,
      //childrens: [],
      childrens: [
        {
          name: this.translateService.instant("General Data"),
          route: '/admin/master-data',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Areas"),
          route: 'admin/master-new/areas',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        }
      ],
      display:true
    },
    // {
    //   name: this.translateService.instant("Master data"),
    //   route: '/admin/master-data',
    //   role: ['Admin'],
    //   hasPermission: false,
    //   permission: null,
    //   childrens: [],
    //   display:true
    // },
    {
      name: this.translateService.instant("Accounts"),
      //role: [],
      display:true,
      role: ['Admin'],
      hasPermission: true,
      permission: [StaticPermissionsEnum.View_customers_list, StaticPermissionsEnum.View_Teams_Report],
      childrens: [
        {
          name: this.translateService.instant("Users"),
          route: '/admin/user-management',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Team"),
          route: '/admin/team-management',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Teams Report"),
          route: '/admin/team-management/teams-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Teams_Report,
          display:true
        }, 
        {
          name: this.translateService.instant("Material Teams Report"),
          route: '/admin/team-management/orders-material-report',
          role: ['Admin', 'Dispatcher', 'Engineer'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Customers"),
          route: '/customer/customersList',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_customers_list,
          display:true,
        }
        ,
        {
          name: this.translateService.instant("Customers Report"),
          route: '/customer/CustomersReport',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Customers_Report,
          display:true,
        },
        {
          name: this.translateService.instant("Roles"),
          route: "/admin/role-management/list",
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        }//,
        // {
        //   name: this.translateService.instant("DeleteRequests"),
        //   route: '/customer/requestsList',
        //   role: [],
        //   hasPermission: true,
        //   permission: StaticPermissionsEnum.View_Customer_Delete_Requests,
        // }
      ]
    },
    {
      name: this.translateService.instant("ContractsManagement"),//ContractsManagement
      role: ['Admin'],
      display:true,
      route: '/contracts/',
      hasPermission: true,
      permission: [StaticPermissionsEnum.View_contracts_list,
      StaticPermissionsEnum.View_invoices,
      StaticPermissionsEnum.Update_contract_settings,
      StaticPermissionsEnum.Contracts_Report, StaticPermissionsEnum.Statement_Of_Customer_Report,
      StaticPermissionsEnum.Paid_Or_Unpaid_Invoices_Report],
      childrens: [
        {
          name: this.translateService.instant("Contracts"),
          route: '/contracts/list',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_contracts_list,
          display:true,
        },
        {
          name: this.translateService.instant("archived Contracts"),
          route: '/contracts/archived',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_contracts_list,
          display:true,
        },
        {
          name: this.translateService.instant("invoices"),
          route: '/contracts/invoices-list',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_invoices,
          display:true,

        },
        {
          name: this.translateService.instant('Contracts Report'),
          route: '/contracts/contracts-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Contracts_Report,
          display:true,
        },
        {
          name: this.translateService.instant('Paid/Unpaid Invoices Report'),
          route: '/contracts/paid-unpaid-invoices',
          role: ['Admin'],
          hasPermission: true,
          permission: StaticPermissionsEnum.Paid_Or_Unpaid_Invoices_Report,
          display:true,
        },
        {

          name: this.translateService.instant('Statement Of Account Report'),
          hasPermission: true,
          permission: StaticPermissionsEnum.Statement_Of_Customer_Report,
          route: "/contracts/account-report",
          role: ['Admin'],
          display:true,
        },
        {
          name: this.translateService.instant('Contracts Settings'),
          route: '/contracts/contract-settings',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Invoices Report"),
          route: '/contracts/invoices-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_invoices,
          configKey: 9,
          display:true,

        },
        {
          name: this.translateService.instant("Invoice Detiales Report"),
          route: '/contracts/invoice-detailes-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Invoice_Detailes_Report,
          configKey: 22,
          display:true,

        }
      ]

    },
    {
      name: this.translateService.instant("Orders Management"),
      role: ['Admin', 'Supervisor', 'Dispatcher', 'Call Center', 'Supervisor CallCenter', 'Foreman'],
      hasPermission: true,
      display:true,
      permission: StaticPermissionsEnum.View_orders_list,
      notAdmin: true,
      childrens: [
        {
          name: this.translateService.instant("Supervisor Board"),
          route: '/supervisor/board',
          role: ['Supervisor'],//, 'Engineer'
          hasPermission: false,
          notAdmin: true,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Dispatcher Board"),
          route: '/supervisor/dispatcher/',
          role: ['Supervisor'], //Supervisor role permissions //, 'Engineer'
          hasPermission: false,
          notAdmin: true,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Orders Board"),
          route: '/dispatcher/board',
          role: ['Dispatcher'],//Dispatcher role permissions
          hasPermission: false,
          notAdmin: true,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Map board"),
          route: '/dispatcher/map',
          role: ['Dispatcher'],//Dispatcher role permissions
          hasPermission: false,
          notAdmin: true,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Re-assign Order"),
          route: '/dispatcher/orders-reassignment',
          role: ['Dispatcher'],
          hasPermission: false,
          notAdmin: true,
          display:true,
          // permission: [StaticPermissionsEnum]
        },
        {
          name: this.translateService.instant("Re-assign Order"),
          route: '/supervisor/orders-reassignment',
          role: ['Supervisor'],
          hasPermission: false,
          notAdmin: true,
          display:true,
          // permission: [StaticPermissionsEnum]
        },
        {
          name: this.translateService.instant("Printout"),
          route: '/dispatcher/printout',
          role: [''],
          hasPermission: false,
          permission: null,
          notAdmin: true,
          display:true,
        },
        {
          name: this.translateService.instant("Orders"),
          route: '/customer/orders',
          role: ['Call Center', 'Supervisor CallCenter'],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_orders_list,
          notAdmin: true,
          display:true,
        },
        {
          name: this.translateService.instant("Guest Orders"),
          route: '/customer/GuestOrderLanding',
          role: ['Call Center', 'Supervisor CallCenter','Dispatcher'],
          hasPermission: true,
          permission:[StaticPermissionsEnum.View_Guest_Orders_List],  
          notAdmin: true,
          display:true,
        },
        {
          name: this.translateService.instant("Foreman Board"),
          route: '/foreman/board',
          role: ['Foreman'],
          hasPermission: true,
          permission: null,
          notAdmin: true,
          display:true,
        },
        {
          name: this.translateService.instant("Calendar"),
          route: '/customer/orders-calender',
          role: ['Supervisor', 'Dispatcher', 'Admin', 'Call Center'],
          hasPermission: false,
          permission: null,
          display:true,
        },
      ]
    },
    {
      name: this.translateService.instant("Inventory"),//Inventory
      role: [],
      display:true,
      hasPermission: true,
      permission: [StaticPermissionsEnum.View_materials_list,
      StaticPermissionsEnum.View_services_list,
      StaticPermissionsEnum.Issue_materials,
      StaticPermissionsEnum.Update_price_list,
      StaticPermissionsEnum.View_material_Free_requests,
      StaticPermissionsEnum.View_Invoice_Discount_Requests,
      StaticPermissionsEnum.Update_material_approval_cycle,
      StaticPermissionsEnum.View_material_report,
      StaticPermissionsEnum.Update_materials_settings,
      StaticPermissionsEnum.View_Material_Issue_Requests,
      StaticPermissionsEnum.View_Stock_To_Service_Request,
      StaticPermissionsEnum.View_Material_Return_Requests],
      childrens: [
        {
          name: this.translateService.instant("Services"),
          route: '/admin/services',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_services_list,
          configKey: 10,
          display:true,
          notAdmin:true,
        },
        {
          name: this.translateService.instant("Materials"),
          route: '/admin/materials',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_materials_list,
          display:true,
        },
        {
          name: this.translateService.instant("Assign material to team"),
           route: '/admin/issue-materials/assign-materials-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Issue_materials,
         // configKey: 20,
          display:true,
        },
        {
          name: this.translateService.instant("Assign material report"),
route: '/admin/issue-materials',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Issue_materials,
          // configKey: 20,
          display: true,
        },
        {
          name: this.translateService.instant("Price List"),
          route: '/admin/materials/price-list',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Update_price_list,
          display:true,
        },
        {
          name: this.translateService.instant("Material cost Report"),
          route: '/admin/materials/material-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_material_report,
          display:true,
        },
        //{
        //    name: this.translateService.instant("Settings"),
        //    route: '',
        //    role: [],
        //    hasPermission: true,
        //    permission: StaticPermissionsEnum.Update_materials_settings
        //},
        {
          name: this.translateService.instant("Free Materials-Services Requests"),
          route: '/admin/materials/free-requests',
          role: [],
          hasPermission: true,
          permission: [StaticPermissionsEnum.View_Invoice_Discount_Requests, StaticPermissionsEnum.View_material_Free_requests],
          display:true,
        },
        {
          name: this.translateService.instant("Approval Cycle"),
          route: '/admin/materials/approve-material',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Update_material_approval_cycle,
          display:true,
        },
        {
          name: this.translateService.instant("Issue materials requests"),
          route: '/admin/materials/issue-requests',
          role: [],
          hasPermission: true,
          permission: [StaticPermissionsEnum.View_Material_Issue_Requests, StaticPermissionsEnum.View_Stock_To_Service_Request, StaticPermissionsEnum.View_Material_Return_Requests],
          display:true,
        },
        {
          name: this.translateService.instant("STS Approval Cycle"),
          route: '/admin/materials/sts-approval',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Update_material_approval_cycle,
          display:true,
        },
        {
          name: this.translateService.instant("Inventory Transactions"),
          route: '/admin/materials/inventory-transactions',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Inventory_Transactions,
          display:true,
          configKey: 57,
        },
      ]
    },
    {
      name: this.translateService.instant("Reports"),//reports
      role: ['Supervisor', 'Foreman', 'Engineer', 'Admin', 'Dispatcher', 'Call Center', 'Finance', 'ContractAdministrator', 'Supervisor CallCenter'],
      hasPermission: false,
      display:true,
      permission: null,
      childrens: [
        {
          name: this.translateService.instant("Order Report"),
          route: '/supervisor/order-management-report/',
          role: ['Supervisor', 'Foreman', 'Engineer', 'Admin', 'Dispatcher', 'Call Center', 'Finance', 'ContractAdministrator', 'Supervisor CallCenter'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Timesheet"),
          route: '/admin/timesheet',
          role: ['Admin', 'Foreman'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Dashboard"),
          route: '/admin/dashboard',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_NewDashboard,
          display:true,
        },
        {
          name: this.translateService.instant("Tracking"),
          route: 'tracking',
         role: [],
         hasPermission: false,
        // permission: StaticPermissionsEnum.View_Tracking_Link,
         display:true,
        },
        {
          name: this.translateService.instant("Payment Gateway Transaction Report"),
          route: '/contracts/pg-report',
          role: ['Supervisor', 'Foreman', 'Engineer', 'Admin', 'Dispatcher', 'Call Center', 'Finance', 'ContractAdministrator', 'Supervisor CallCenter'],
          hasPermission: false,
          permission: null,
          configKey: 110,
          display:true,
        },
        {
          name: this.translateService.instant("OrderProfitReport"),
          route: '/admin/materials/order-profit-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Profit_Report,
          configKey: 55,
          display:true,
        },
        {
          name: this.translateService.instant("Contract Revenue Allocation Report"),
          route: '/contracts/contract-revenue-allocation-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Print_ContractRevenueAllocation,
          display:true,
        },
        {
          name: this.translateService.instant("Unit Report"),
          route: '/admin/unit-report',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.Print_ContractRevenueAllocation,
          display:true,
        },
        {
          name: this.translateService.instant("ExportedFiles"),
          route: '/admin/exported-files',
          role: [],
          hasPermission: true,
          permission: StaticPermissionsEnum.View_Exported_Files,
          display:true,
        },
        {
          name: this.translateService.instant("Preventive Maintenance Report"),
          route: '/admin/preventive-maintenance-report',
          role: ['Admin', 'Dispatcher', 'Supervisor'],
          hasPermission: false,
          permission:null,
          display:true,
        }
        // {
        //   name: this.translateService.instant("CustomerRateReport"),
        //   route: '/admin/customer-rate-report',
        //  role: ['Supervisor', 'Foreman', 'Engineer', 'Admin', 'Dispatcher', 'Call Center', 'Finance', 'ContractAdministrator', 'Supervisor CallCenter'],
        //   hasPermission: false,
        //   permission: null,
        //   display:true,
        // },

        ,{
          name: this.translateService.instant("WhatsApp Log"),
          route: '/admin/whatsapp-log-report',
          role: ['Admin', 'Supervisor', 'Dispatcher', 'Call Center', 'Supervisor CallCenter'],
          permission: null,
          configKey: 1700,   
          display: true,
        }
      ]

    },
    
    {
      name: this.translateService.instant("Settings"),//Settings
      role: ['Admin'],
      display:true,
      hasPermission: false,
      permission: null,
      childrens: [

        {
          name: this.translateService.instant("Dispatching Settings"),
          route: '/admin/dispatcher-settings',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },
        {
          name: this.translateService.instant("Email Settings"),
          route: '/admin/email-settings',
          role: ['Admin'],
          hasPermission: false,
          permission: null,
          display:true,
        },

        {
          name: this.translateService.instant("General  Settings"),
          route: '/admin/map-settings',
          role: ['Admin'],
          permission: null,
          hasPermission: false,
          display:true,
        },
        {
          name: this.translateService.instant("Company Profile"),
          route: '/admin/company-profile',
          role: ['Admin'],
          permission: null,
          hasPermission: false,
          display:true,
        }
        ,
        {
          name: this.translateService.instant("Subscription"),
          route: '/admin/my-subscription',
          role: ['Admin'],
          permission: null,
          hasPermission: false,
          configKey: StaticConfigurationsEnum.IsSubscriptionBased,
          config: false, // shown only when IsSubscriptionBased config (1850) is true
          display: true,
        }
        ,

                {
                    name: this.translateService.instant("Terms & Conditions"),
                    route: '/admin/map-settings/terms-conditions',
                    role: ['Admin'],
                    permission: null,
                    hasPermission: false,
                    display:true,
                }
            ]
        },
        {
            name: this.translateService.instant("Customer Search"),
            role: [],
            display:true,
            hasPermission: true,
            notAdmin: true,
            permission: StaticPermissionsEnum.View_customer_dashboard,
            childrens: [],
            route: '/customer/customersearch'
        },
        {
            name: this.translateService.instant("Sales"),
            role: ['Admin'],
            display:true,
            hasPermission: true,
            permission: [
                StaticPermissionsEnum.View_Quotations_List,
                StaticPermissionsEnum.Lead_Listing,
                StaticPermissionsEnum.Quotation_PriceList_Listing,
                StaticPermissionsEnum.Opportunity_Listing,
                StaticPermissionsEnum.MCPotential_Listing
            ],
            childrens: [
                {
                    name: this.translateService.instant('Quotations'),
                    route: '/contracts/quotations',
                    role: ['Admin'],
                    hasPermission: true,
                    permission: StaticPermissionsEnum.View_Quotations_List,
                    configKey: 1,
                    display:true,
                },
                {
                    name: this.translateService.instant('Quotations Discount Approval Cycle'),
                    route: '/contracts/quotations/discount-multi-level-approval-cycle',
                    role: ['Admin'],
                    hasPermission: true,
                    configKey: 4,
                    display:true,
                },
                {
                    name: this.translateService.instant('Leads'),
                    route: '/contracts/quotations/lead',
                    role: ['Admin'],
                    hasPermission: true,
                    permission: StaticPermissionsEnum.Lead_Listing,
                    configKey: 5,
                    display:true,
                },
                {
                    name: this.translateService.instant('Price List'),
                    route: '/contracts/quotations/price-list',
                    role: ['Admin'],
                    hasPermission: true,
                    permission: StaticPermissionsEnum.Quotation_PriceList_Listing,
                    configKey: 1,
                    display:true,
                },
                {
                    name: this.translateService.instant('Opportunities'),
                    route: '/contracts/quotations/opportunity',
                    role: ['Admin'],
                    hasPermission: true,
                    permission: StaticPermissionsEnum.Opportunity_Listing,
                    configKey: 3,
                    display:true,
                },
                {
                    name: this.translateService.instant('MC Potential'),
                    route: '/contracts/quotations/mc-potential',
                    role: ['Admin'],
                    hasPermission: true,
                    permission: StaticPermissionsEnum.MCPotential_Listing,
                    configKey: 2,
                    display:true,
                },
            ]
        }
    ];

  constructor(
    private translateService: TranslateService,
    private authPermissionsService: AuthPermissionsService
  ) { }

  get menu() {
    return this.items;
  }
}
